/* unplugin-vue-components disabled */import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export default {
  __name: 'Workspace',
  setup(__props) {
    const workspaceRef = ref(null);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        id: "workspace",
        ref_key: "workspaceRef",
        ref: workspaceRef,
        class: "workspace relative h-full overflow-hidden bg-editor2d"
      }, [_renderSlot(_ctx.$slots, "default")], 512);
    };
  }
};